import type { ColDef, RowDoubleClickedEvent } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { Input, message } from 'antd';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { FilingProps, FilingHistoryData, LateFilingData, FetchLateResponse, FetchLateResult, FilingData, RowFiling } from '../constant';
import { api_fetchFilingbyDtrId, api_updateDTR, FectchLateFilings } from "../api/getLateFilings";
import SendMailButtonComponent from '../components/SendMailButtonComponent'
import {  ResendDTRConfirm } from '../api/resendconfirm';
import { DownloadExcelHistory } from '../api/excelhistory';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay';

import {
    AllCommunityModule,
    CheckboxEditorModule,
    ClientSideRowModelModule,
    ModuleRegistry,
    themeQuartz,
    ValidationModule
} from "ag-grid-community";
import moment from 'moment';
import { convertToRowFiling, isFetchFilingResponse, isUpdateDTRResponse } from '../common';
import CustomSelectCellEditor from '../components/CustomSelectCellEditor';
import CustomSelectCellRenderer from '../components/CustomSelectCell';

ModuleRegistry.registerModules([AllCommunityModule, CheckboxEditorModule, ClientSideRowModelModule, ValidationModule]);

const HeaderStyle: React.CSSProperties = {
    height: '50px',
};

const isFilingLateResponse = (result: FetchLateResult): result is FetchLateResponse => {
    return result.success === true; 
}

  export interface LateFilingProps{
    user: {[key: string]: string},
    carriers: string[],
    users: { [key: string]: string },
    slcodes: { [key: string]: string },
    isSelected: boolean,
    setActiveKey: (key: string) => void
    setLateSearch: (policynumber: string) => void
    setLateLicense: (licenseNumber: string) => void
  }

const LateFilings: React.FC<LateFilingProps> = ({user, slcodes, setActiveKey, setLateSearch, setLateLicense}) => {

    const [loading, setLoading] = useState(false)
    const [rowData, setRowData] = useState<LateFilingData[]>([]);
    const [lateList, setLateList] = useState<LateFilingData[]>([]);
    const [loadingMessage, setLoadingMessage] = useState('');
    const listRef = useRef(lateList);
    const [filingList, setFilingList] = useState<FilingData[]>([]);
    const [rowFilingData, setRowDataFiling] = useState<RowFiling[]>([]);
    const [selectedLicense, setSelectedLicense] = useState<string>("");
    const [isshowall, setIsShowAll] = useState<boolean>(false);

    const [colDefs, setColDefs] = useState<ColDef[]>([
        // { 
        //     headerClass: 'mail-header',
        //     headerName : "",
        //     field: "mail",
        //     editable: false,
        //     width: 30,
        //     cellRenderer: (params: any) => (
        //         <SendMailButtonComponent
        //             api={params.api}
        //             node={params.node}
        //             onEmailButton={onSendMail}
        //         />
        //       ),
        // },
        { headerName:'DTR ID', field: "DTRID", width: 100, resizable: true},
        { headerName:'Date Sent', field: "date", width: 100, resizable: true, 
            valueFormatter: (params) => {
            const value = params.value;
            return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        { headerName:'License', field: "license", width: 100, resizable: true},
        { headerName:'Broker Name', field: "broker", width: 90, resizable: true, cellStyle: { textAlign: "left" }},
        { headerName:'Tax Due', field: "tax", width: 120, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        { headerName:'Penalty Due', field: "penalty", width: 120, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        { headerName:'Date Due', field: "duedate", width: 100, resizable: true},
        { headerName:'Balance', field: "balance", width: 120, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
        },
        { headerName:'Paid Amount', field: "paidamount", width: 120, resizable: true , cellStyle: { textAlign: "right" }, editable: true , 
            valueFormatter: (params: any) => {
                return parseFloat(params.value).toFixed(2);
            },
            hide: user.userType !== '0' ? false : true
        },
        {
            headerName: 'Status', field: "status", width: 150, resizable: true,
            editable: true,
            cellEditorParams: {
            values: ['Pending', 'Void', 'Paid'],
            valueSetter: (params: any) => {
                params.data.transType = params.newValue;
                return true;
            },
            },
            cellEditor: CustomSelectCellEditor,
            cellRenderer:CustomSelectCellRenderer,
            hide: user.userType !== '0' ? false : true
        },
        { headerName:'Notes', field: "notes", width: 500, resizable: true, cellStyle: { textAlign: "left" }, hide: user.userType !== '0' ? false : true, editable: true,},
        
    ]);

    const [colDTRDefs, setcolDTRDefs] = useState<ColDef[]>([
            { headerName:'Policy Number', field: "policynumber", width: 150, resizable: true,  cellStyle: { textAlign: "left" }},
            { headerName:'Insured Name', field: "insuredName", width: 200, resizable: true,  cellStyle: { textAlign: "left" }},
            { headerName:'Transaction Effective Date', field: "transEffectiveDate", width: 100, resizable: true, 
                valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
                },
            },
            { headerName:'Transaction Date', field: "transDate", width: 100, resizable: true, 
                valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
                },
            },
            { headerName:'Premium', field: "premium", width: 90, resizable: true ,  cellStyle: { textAlign: "right" } },
            { headerName:'Policy Fees', field: "policyFee", width: 70, resizable: true ,  cellStyle: { textAlign: "right" }},
            { headerName:'Tax', field: "tax", width: 80, resizable: true, editable: false,  cellStyle: { textAlign: "right" }},
            { headerName:'Period', field: "period", width: 100, resizable: true,  cellStyle: { textAlign: "right" }},
            { headerName:'Penalty', field: "latefee", width: 100, resizable: true,  cellStyle: { textAlign: "right" }},
        ]);

    useEffect(() => {
        listRef.current = lateList;
    }, [lateList]);

    useEffect(() => {

        setLoading(true)
        console.log("user.licenseNumber = ", user.licenseNumber)
        // const license = user.userType !== '0' ? "" : user.licenseNumber
        let license = user.licenseNumber
        if (user.userType !== '0' && isshowall)
            license = ""  
        
        FectchLateFilings(license)
        .then((fetchlateResult) => {
            if (fetchlateResult.success)
            {
                //message.success({ content: 'Successfully loaded Filing History', key: 'historyStatus', duration: 2  });

                if (isFilingLateResponse(fetchlateResult))
                {
                    setLateList(fetchlateResult.filing)
                    setRowData(fetchlateResult.filing)
                }
            }
            else{
                message.error({ content: 'Failed to load the filing history', key: 'lateStatus', duration: 2  });
                if ("errorMsg" in fetchlateResult) {
                    message.error(fetchlateResult.errorMsg)
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        })
        .finally(() => {
            setLoading(false)
        });
      },[user.licenseNumber, isshowall]);

    
    const onSendMail = (rowIndex: number) =>{
        console.log(`DTRID = ${listRef.current[rowIndex].DTRID}`)
        message.loading({ content: 'Sending DTR...', key: 'senddtr', duration: 0 });
        
        ResendDTRConfirm(listRef.current[rowIndex].DTRID)
        .then((response) => {
          if (response.success)
          {
            message.success({ content: response.errorMsg, key: 'senddtr', duration: 2 })
          }
          else{
            if ("errorMsg" in response) {
                message.error({ content: response.errorMsg, key: 'senddtr', duration: 2 })
            }
          }
        })
        .catch((error) => {
          console.error("An error occurred:", error.message);
          return
        });
    }

    const defaultColDef = useMemo<ColDef>(() => {
    return {
        headerClass: 'custom-header',
        sortable: false,
    };
    }, []);

    const myTheme = themeQuartz
    .withParams({
        headerColumnBorder: { color: 'gray' },
        headerColumnBorderHeight: '90%',
    });

    const onCellValueChanged = (params: any) => {
        
        const updateRow = lateList[params.rowIndex]
        updateRow.status = params.data.status
        updateRow.paidamount = params.data.paidamount
        updateRow.notes = params.data.notes
    
        api_updateDTR(updateRow)
            .then((response) => {
            if (response.success) {
                if (isUpdateDTRResponse(response)) {
                    const updatedDtr = [...lateList];
                    updatedDtr[params.rowIndex] = response.dtr
                    setLateList(updatedDtr);
                }
            }
            else {
                if ("errorMsg" in response) {
                message.error(response.errorMsg)
                }
            }
            })
            .catch((error) => {
            console.error("An error occurred:", error.message);
            return
            });
    };

    const onCellDoubleClicked = (params: any) => {
        console.log('cellDoubleClicked', params.node.data?.DTRID);
        if (params.node.data?.DTRID === undefined) {
            return
        }

        if (params.colDef.field === "status" || params.colDef.field === "paidamount" || params.colDef.field === "note")
        {
            return
        }

        setSelectedLicense(params.node.data?.license)

        setLoading(true)
        setLoadingMessage('Loading...')
        api_fetchFilingbyDtrId(params.node.data?.DTRID)
            .then((response) => {
            if (response.success) {
                if (isFetchFilingResponse(response)) {
                    setFilingList(response.fetchedList)
                    setRowDataFiling(convertToRowFiling(response.fetchedList, slcodes))
                }
            }
            else {
                if ("errorMsg" in response) {
                message.error({ content: 'Failed to load the Filing.', key: 'FilingStatus', duration: 2 });
                }
            }
            })
            .catch((error) => {
            console.error("An error occurred:", error.message);
            })
            .finally(() => {
            setLoading(false);
            });
    };

    const onRowDoubleClicked = (event: RowDoubleClickedEvent<LateFilingData>) => {
        console.log(`RowDoubleClick = ${event.data?.DTRID}`)
    };
    
    const onDetailRowDoubleClicked = (event: RowDoubleClickedEvent<RowFiling>) => {
        console.log(`RowDetailDoubleClick = ${event.data?.policynumber}`)
        setLateSearch(event.data?.policynumber ? event.data.policynumber : "")
        setLateLicense(selectedLicense)
        setActiveKey("3")
    };
    
    const isValidate = (data: any) => {
        return true
    }

    const onClickExcelBtn = () => {
        DownloadExcelHistory(user.licenseNumber)
            .then((response) => {
            if (response.success)
            {
                message.success(response.errorMsg)
            }
            else{
                message.error(response.errorMsg)
            }
            })
            .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        });
    }
  
    return(
        // <div style={{height:'100%'}} className='text-style'>

        // </div>
       
        <div style={{height:'100%'}} className='text-style'>
            <div className="flex justify-between items-center bg-gray-100" style={HeaderStyle}>
                <div className='flex flex-row ml-10 text-xs'>
                    <div><span> Deliquent tax reports (E-DTR) are processed during the first week of each month. If you had late filings in the current month you will get a DTR the first week of next month and that DTR will also be shown here.</span></div>
                </div>
                <div className='flex mr-10 text-xs'>
                    <Input
                        type='checkbox'
                        checked={isshowall}
                        className='w-4 h-4'
                        onChange={(e) => setIsShowAll(e.target.checked)}
                    />
                    <label className="font-medium ml-1 w-24">Show All</label>
                </div>
                {/* <Button 
                variant="outlined" 
                type='primary'
                onClick={onClickExcelBtn}
                icon={<FileExcelOutlined className='icon-style'/>} 
                className='ml-0.5, mr-20 button-style'>
                    Save to Excel
                </Button> */}
            </div>
            <div className="flex flex-col tab-container">
                <div className="flex-1">
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={colDefs}
                        theme={myTheme}
                        defaultColDef={defaultColDef}
                        headerHeight={35}
                        rowHeight={25}
                        onCellValueChanged={onCellValueChanged}
                        onCellDoubleClicked={onCellDoubleClicked}
                        onCellClicked={onCellDoubleClicked}
                        onRowDoubleClicked={onRowDoubleClicked}
                        loading={loading}
                        loadingOverlayComponent={CustomLoadingOverlay}
                        loadingOverlayComponentParams={{ message: "Loading..." }}
                    />
                </div>
                <div className='flex ml-10 text-xs mt-2 mb-2'>
                    <span> Below are the transactions that belong to the selected DTR.  Double click a policy number to see a full policy detail in Filing Search</span>
                </div>
                <div className="flex-1">
                    <AgGridReact
                        rowData={rowFilingData}
                        columnDefs={colDTRDefs}
                        theme={myTheme}
                        defaultColDef={defaultColDef}
                        headerHeight={35}
                        rowHeight={25}
                        loading={loading}
                        loadingOverlayComponent={CustomLoadingOverlay}
                        onRowDoubleClicked={onDetailRowDoubleClicked}
                        loadingOverlayComponentParams={{message: "Loading..."}}
                    />
                </div>
            </div>
        </div>
    )
}

export default LateFilings;